// The portal's preset student/parent avatars (src/app/assets/svgs/usersAvatars), picked by avatarImageName.
import Avatar25 from "app/assets/portal/avatars/avatar-02-25.svg";
import Avatar1 from "app/assets/portal/avatars/avatar-02_1.svg";
import Avatar11 from "app/assets/portal/avatars/avatar-02_11.svg";
import Avatar12 from "app/assets/portal/avatars/avatar-02_12.svg";
import Avatar14 from "app/assets/portal/avatars/avatar-02_14.svg";
import Avatar15 from "app/assets/portal/avatars/avatar-02_15.svg";
import Avatar16 from "app/assets/portal/avatars/avatar-02_16.svg";
import Avatar17 from "app/assets/portal/avatars/avatar-02_17.svg";
import Avatar19 from "app/assets/portal/avatars/avatar-02_19.svg";
import Avatar2 from "app/assets/portal/avatars/avatar-02_2.svg";
import Avatar20 from "app/assets/portal/avatars/avatar-02_20.svg";
import Avatar21 from "app/assets/portal/avatars/avatar-02_21.svg";
import Avatar24 from "app/assets/portal/avatars/avatar-02_24.svg";
import Avatar4 from "app/assets/portal/avatars/avatar-02_4.svg";
import Avatar5 from "app/assets/portal/avatars/avatar-02_5.svg";
import Avatar6 from "app/assets/portal/avatars/avatar-02_6.svg";
import Avatar7 from "app/assets/portal/avatars/avatar-02_7.svg";
import Avatar8 from "app/assets/portal/avatars/avatar-02_8.svg";
import Avatar9 from "app/assets/portal/avatars/avatar-02_9.svg";

export const avatarsMap: Record<string, string> = {
  Avatar1, Avatar2, Avatar4, Avatar5, Avatar6, Avatar7, Avatar8, Avatar9, Avatar11, Avatar12, Avatar14, Avatar15, Avatar16, Avatar17, Avatar19, Avatar20, Avatar21, Avatar24, Avatar25,
};

/** The avatar image for a portal avatarImageName, or null when none was chosen. */
export const avatarFor = (name: string | null | undefined): string | null => (name && avatarsMap[name]) || null;

const PALETTE = ["#4C54A0", "#45B1B2", "#FF914D", "#50B5FF", "#9D4EDD", "#2A9D8F", "#E63946", "#277DA1"];
export const colourFor = (name: string) => {
  let h = 0; for (const ch of name.toLowerCase()) h = ch.charCodeAt(0) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
};
export const initials = (fullName = "") => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  return parts.length === 1 ? parts[0][0].toUpperCase() : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
